import date from '@/components/kit/date'

export const state = () => ({ continuationToken: null })

export const mutations = {
  setContinuationToken(state, value) {
    state.continuationToken = value
  }
}

export const actions = {
  async getAlertData({ dispatch, commit, state }, { applianceId }) {
    const continuationToken = state.continuationToken
    const data = await this.$apiAaltra.alerts(applianceId, continuationToken)

    await commit('setContinuationToken', data.continuation)

    const result = []
    if (data.days) {
      for (let i = 0; i < data.days.length; i++) {
        const d = data.days[i]
        const applianceDate = date.toLongDateFormat(
          d.timestamp,
          this.app.i18n.locale
        )

        const alerts = await dispatch('mapManyToAlertList', d.items)

        result.push({
          _applianceId: applianceId || d.items[0].id,
          _label: applianceDate,
          data: alerts
        })
      }
    }
    return result
  },

  mapManyToAlertList(_, alerts) {
    return alerts.map((alert) => {
      return {
        _new: alert.new,
        text: [
          this.app.i18n.t(this.$applianceType(alert.id).name),
          this.$formatTime(alert.alertTime),
          this.$formatPercentage(alert.percentageConsumption)
        ]
      }
    })
  }
}
